/* eslint-disable */

//             ,d
//             88
// ,adPPYba, MM88MMM ,adPPYba,  8b,dPPYba,
// I8[    ""   88   a8"     "8a 88P'    "8a
// `"Y8ba,     88   8b       d8 88       d8
// aa    ]8I   88,  "8a,   ,a8" 88b,   ,a8"
// `"YbbdP"'   "Y888 `"YbbdP"'  88`YbbdP"'
//                             88
//                             88


//////////////////////////////////
//////////////////////////////////
//
//  DO NOT EDIT THIS FILE. THIS FILE IS AUTO GENERATED BASED ON .docs.tsx COMPONENTS
//  INSIDE EACH DESIGN SYSTEM COMPONENT. TO EDIT THIS FILE, EDIT IT'S CORESPONDING .docs.tsx and .docs.json FILE
//  AND RERUN `yarn build-design-docs`
//
//////////////////////////////////
//////////////////////////////////

import React from 'react';

import { WpPageLayout, WpPageHeader, WpPageTitle, WpPageBody } from '../../../components/page-layout';
import ButtonsDocs from 'Wpds/components/button/_docs/Buttons.docs';

const ButtonsPage = () => (
  <WpPageLayout>
    <WpPageHeader sticky>
      <WpPageTitle title="Buttons" />
    </WpPageHeader>
    <WpPageBody><ButtonsDocs /></WpPageBody>
  </WpPageLayout>
);
export default ButtonsPage;
